const { WASTE_PLAN_KEYS, PPWR_PLAN_KEYS } = require('./plans');

const MODULES = {
    waste: 'Evidencia odpadov',
    operationalLog: 'Prevádzkový denník',
    ppwr: 'PPWR obaly',
};

const MODULE_KEYS = Object.keys(MODULES);

// Modules that carry their own subscription/plan and can be sold as a package.
const BILLABLE_MODULE_PLAN_KEYS = {
    waste: WASTE_PLAN_KEYS,
    ppwr: PPWR_PLAN_KEYS,
};

const BILLABLE_MODULE_KEYS = Object.keys(BILLABLE_MODULE_PLAN_KEYS);

module.exports = { MODULES, MODULE_KEYS, BILLABLE_MODULE_PLAN_KEYS, BILLABLE_MODULE_KEYS };
